export default {
  login: {
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    verifycode: 'Verify Code'
  },
  mobile: {
    PwCYouPlusProgramme: '普华永道 You Plus 特训计划',
    PwCYouPlusAnchorPro: '普华永道 You Plus Anchor Pro',
    more: '更多',
    home: '首页',
    careerDevelopment: '职业发展',
    careerInsights: '求职干货',
    latestEvents: '最新活动',
    careerOpportunities: '实习和就业机会',
    careerProgrammes: '竞争力提升项目',
    capabilityDiagnosis: '求职测评',
    peerSharing: '同龄人',
    peerStories: '学员故事',
    highlightMoments: '高光专栏',
    campusAmbassador: '校园大使',
    callForLetters: '征稿专栏',
    internshipChallenge: '挑战营',
    careerCapabilitySelfDiagnosis: '自我测评',
    on1CustomisedCounselling: '职业发展一对一咨询',
    diagnose: '开始测评',
    goApply: '我要申请',
    apply: '报名',
    applied: '已报名',
    completed: '已完成',
    reject: '拒绝',
    accept: '接受',
    consulted: '咨询已提交',
    consult: '预约咨询'
  }
}
